import React, { useContext, useEffect, useState } from 'react';
import styles from './ChatListItem.module.scss'
import MessageContext from '../../../../context/MessageContext';
import Avatar from '../../../../components/Avatar/Avatar';



export default function ChatListItem({ chatLog }: any) {
    const { setChat, setOpenMessage , isOpenMessage}: any = useContext(MessageContext);

    const openMessage = ()=> {
      setChat(chatLog);
    }

  return (
    <div onClick={openMessage} className={styles.listItem}>
      <Avatar
        alt={chatLog.fullName}
        src={chatLog.picture}
        status={chatLog.status}
        size="44"
      />
      <div className={styles.itemText}>
        <div className={styles.userInfo}>
          <h4>{chatLog.fullName}</h4>
          <span>{chatLog.lastChatTime}</span>
        </div>
        <h5 className={styles.userName}>{chatLog.userName}</h5>
        <p className={styles.messageSummary}>{chatLog.lastMessage}</p>
      </div>

      {/* unread message */}
      {chatLog.isUnread && <span className={styles.unread}></span>}
    </div>
  );
}
